import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * MenuGenius theme provider.
 * - `class` strategy: toggles `.dark` on <html>.
 * - Defaults to system preference.
 * - Stored in localStorage under "menugenius-theme".
 */
export function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="menugenius-theme"
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}

export default ThemeProvider;
